import { render, staticRenderFns } from "./DuplicationContratPorteuse.vue?vue&type=template&id=223940ab&"
import script from "./DuplicationContratPorteuse.vue?vue&type=script&lang=js&"
export * from "./DuplicationContratPorteuse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports